module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/78dfc8e6bd65ebe7a986a4e666772853.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_assignlater.svg
// module id = 8oBE
// module chunks = 0